import formAppConfig from './formAppConfig';
import formConfigLanguage from './formConfigLanguage';
export default {
  title: 'White Label Play Config Form',
  attributeName: 'appConfigs',
  getURL: 'appId/appConfigsPlay',
  updateURL: 'appId/appConfigsPlay',
  idAttribute: 'configId',
  sessionParams: ['appId'],
  formConfig: [formAppConfig, formConfigLanguage],
  formGroupExpands: false,
  autoUpdate: false,
  idUpdate:true,
  noArea: true,
  goBack: false,
};

